import { Text } from '../../cdl/Text/Text';
import { translate } from '../helpers/translate.helper';
import { Box } from '../ui/Box';

interface BooleanStatusProps {
    value: boolean;
    label?: string;
}

export const BooleanStatus = ({
    value,
    label = value ? translate('global.enabled') : translate('global.disabled'),
}: BooleanStatusProps) => (
    <Box display="flex" alignItems="center">
        <Text variant="small">{label}</Text>
        <Box
            backgroundColor={value ? 'positive.emphasis' : 'negative.emphasis'}
            width="6px"
            height="6px"
            marginTop={2}
            marginLeft={8}
            borderRadius="100%"
        />
    </Box>
);
